import { render, staticRenderFns } from "./QualityAlertsCard.vue?vue&type=template&id=5b7b130d&scoped=true&"
import script from "./QualityAlertsCard.vue?vue&type=script&lang=js&"
export * from "./QualityAlertsCard.vue?vue&type=script&lang=js&"
import style0 from "./QualityAlertsCard.vue?vue&type=style&index=0&id=5b7b130d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7b130d",
  null
  
)

export default component.exports